import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CONTENT } from "../data/content";

export const Contact = () => (
    <footer id="contact" className="border-t border-white/10 px-6 pt-28 md:px-12 md:pt-40" data-testid="contact-section">
        <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="font-body text-xs uppercase tracking-[0.4em] text-zinc-500"
        >
            Contact
        </motion.p>
        <motion.a
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            href={`mailto:${CONTENT.email}`}
            data-testid="contact-email-heading"
            className="group mt-6 block font-display text-[16vw] leading-[0.9] tracking-tight text-white transition-colors duration-500 hover:text-[#E50914] md:text-[11vw]"
        >
            LET&rsquo;S SHOOT
            <ArrowUpRight className="ml-4 inline h-[8vw] w-[8vw] transition-transform duration-500 group-hover:-translate-y-2 group-hover:translate-x-2 md:h-[5vw] md:w-[5vw]" />
        </motion.a>

        <div className="mt-20 grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-2 md:grid-cols-4">
            <div className="bg-[#050505] p-8">
                <p className="font-body text-[10px] uppercase tracking-[0.35em] text-zinc-500">Phone</p>
                <a
                    href={`tel:${CONTENT.phone.replace(/[^+\d]/g, "")}`}
                    data-testid="contact-phone-link"
                    className="link-line mt-4 inline-block font-body text-sm text-white"
                >
                    {CONTENT.phone}
                </a>
            </div>
            <div className="bg-[#050505] p-8">
                <p className="font-body text-[10px] uppercase tracking-[0.35em] text-zinc-500">Email</p>
                <a
                    href={`mailto:${CONTENT.email}`}
                    data-testid="contact-email-link"
                    className="link-line mt-4 inline-block break-all font-body text-sm text-white"
                >
                    {CONTENT.email}
                </a>
            </div>
            {CONTENT.socials.map((social) => (
                <div key={social.label} className="bg-[#050505] p-8">
                    <p className="font-body text-[10px] uppercase tracking-[0.35em] text-zinc-500">{social.label}</p>
                    <a
                        href={social.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`social-${social.label.toLowerCase()}-link`}
                        className="link-line mt-4 inline-flex items-center gap-1 font-body text-sm text-white"
                    >
                        @{social.href.replace(/\/$/, "").split("/").pop().replace(/^@/, "")}
                        <ArrowUpRight className="h-3 w-3" />
                    </a>
                </div>
            ))}
        </div>

        <div className="flex flex-col gap-2 py-8 md:flex-row md:items-center md:justify-between">
            <p className="font-body text-[10px] uppercase tracking-[0.3em] text-zinc-600" data-testid="footer-copyright">
                &copy; 2026 {CONTENT.name} — {CONTENT.role}
            </p>
            <p className="font-body text-[10px] uppercase tracking-[0.3em] text-zinc-600">
                35mm / Anamorphic / Large Format
            </p>
        </div>
    </footer>
);
